// extracted by mini-css-extract-plugin
export default {"row":"viewGame_row__QZqso","col":"viewGame_col__pHFlT","card":"viewGame_card__qL6-R"};